import store from "../store";

const tenant = {
  getApiBaseUrl() {
    return process.env.VUE_APP_API.replace(
      "{{domain}}",
      window.location.hostname
    );
  },
  getAppFilesUrl() {
    return process.env.VUE_APP_FILES.replace(
      "{{domain}}",
      window.location.hostname
    );
  },
  getPusherKey() {
    return process.env.VUE_APP_PUSHER_KEY;
  },
  getPusherDomain() {
    return process.env.VUE_APP_PUSHER_DOMAIN.replace(
      "{{domain}}",
      window.location.hostname
    );
  },
  getPusherHttpHost() {
    return process.env.VUE_APP_PUSHER_HTTP_HOST.replace(
      "{{domain}}",
      window.location.hostname
    );
  },
  getPusherAuthEndpoint() {
    return process.env.VUE_APP_PUSHER_AUTH_ENDPOINT.replace(
      "{{domain}}",
      window.location.hostname
    );
  },
  getAppMediaUrl() {
    return process.env.VUE_APP_MEDIA_URL.replace(
      "{{tenant}}",
      tenant.getTenantName()
    );
  },
  getAppVideoUrl() {
    return process.env.VUE_APP_MEDIA_URL.replace(
      "{{tenant}}/images",
      tenant.getTenantName() + "/videos"
    );
  },
  getTenantName() {
    let name = window.location.hostname.split(".")[0];

    return name;
  },
  getTenantUrl() {
    return store.state.webshopBaseUrl;
  },
};

export default tenant;
